import type { Modification } from '../../types';

export function checkIfExtraModification(modification: Modification) {
  return modification.isExtra;
}
